import { AssetStyleInfo } from "../model/internal/assetInfo";

const DEFAULT_CURRENT_COLOR = "black";

const styles: AssetStyleInfo[] = [
  {
    name: "Select",
    class: "select",
    type: "select",
    id: "Select",
    icon: undefined,
  },
  {
    class: "scaling-tool",
    type: "select",
    tool: "ScalingTool",
    id: "ScalingTool",
    icon: undefined,
  },
  {
    name: "Select Group",
    class: "select-group",
    type: "select",
    id: "SelectGroup",
    icon: undefined,
  },
  {
    name: "Re-shape",
    class: "re-shape",
    type: "select",
    id: "Reshape",
    requiredFeature: "EditModeEnabled",
    icon: undefined,
  },
  {
    name: "Select Results",
    class: "select-results",
    type: "select",
    id: "SelectResults",
    requiredFeature: "AssessmentResultsPopupEnabled",
    icon: undefined,
  },
  {
    name: "Split",
    class: "editCable",
    type: "select",
    id: "SplitCable",
    icon: undefined,
  },
  {
    name: "Delete",
    class: "delete",
    type: "delete",
    id: "Delete",
    icon: undefined,
  },
  {
    name: "Delete Group",
    class: "delete-group",
    type: "delete",
    id: "DeleteGroup",
    icon: undefined,
  },
  {
    name: "Ground-mounted Transformer",
    class: "substation-gmt",
    type: "transformer",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "GroundMountedTransformer",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "Pole-mounted Transformer",
    class: "substation-pmt",
    type: "transformer",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "PoleMountedTransformer",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "Underground Cable",
    class: "underground-cable",
    type: "cable",
    tool: "Line",
    weight: "3",
    color: "rgb(52, 58, 64)",
    id: "UndergroundCable",
    layerType: "polyline",
    icon: undefined,
  },
  {
    name: "Overhead Line",
    class: "overhead-line",
    type: "cable",
    tool: "Line",
    weight: "6",
    color: "rgb(52, 58, 64)",
    id: "OverheadLine",
    layerType: "polyline",
    icon: undefined,
  },
  {
    name: "Node",
    class: "node",
    type: "groupedConnection",
    tool: "Marker",
    circleMarker: false,
    borderColor: "transparent",
    size: 3,
    id: "Node",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "Domestic Property",
    class: "domestic",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "DomesticProperty",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "Small Commercial Property",
    class: "small-commercial",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "SmallCommercialProperty",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "Large Commercial Property",
    class: "large-commercial",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "LargeCommercialProperty",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "Industrial Property",
    class: "industrial",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "IndustrialProperty",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "Generator",
    class: "generator",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "Generator",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "Welder",
    class: "welder",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "Welder",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "Motor",
    class: "motor",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "Motor",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "EV Chargepoint",
    class: "evChargePoint",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "EvChargePoint",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "Grouped Connection",
    class: "connection",
    type: "groupedConnection",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "GroupedConnection",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "Heat Pump",
    class: "heatPump",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "HeatPump",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "Map Marker",
    class: "map-marker",
    type: "mapMarker",
    tool: "MapMarker",
    circleMarker: false,
    borderColor: "transparent",
    size: 4,
    id: "MapMarker",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "Point of Connection",
    class: "point-of-connection",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "PointOfConnection",
    requiredFeature: "PointOfConnectionEnabled",
    layerType: "marker",
    icon: undefined,
  },
  {
    name: "Sticky Note",
    class: "sticky-note",
    type: "annotation",
    tool: "Annotation",
    icon: "faStickyNote",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "Annotation",
    layerType: "marker",
    arrowSnapTarget: true,
    requiredFeature: "AnnotationToolsStickyNoteEnabled",
  },
  {
    name: "Rectangle",
    class: "rectangle",
    type: "annotation",
    tool: "Annotation",
    icon: "faSquareFull",
    id: "RectangleAnnotation",
    layerType: "polygon",
    color: "black",
    arrowSnapTarget: true,
    requiredFeature: "AnnotationToolsRectangleEnabled",
  },
  {
    name: "Circle",
    class: "circle",
    type: "annotation",
    tool: "Annotation",
    icon: "faCircle",
    id: "CircleAnnotation",
    layerType: "circle",
    color: "black",
    arrowSnapTarget: true,
    requiredFeature: "AnnotationToolsCircleEnabled",
  },
  {
    name: "Arrow",
    class: "arrow",
    type: "annotation",
    tool: "Annotation",
    icon: "faArrowRight",
    id: "ArrowAnnotation",
    layerType: "arrow",
    color: "black",
    arrowSnapTarget: false,
    requiredFeature: "AnnotationToolsArrowEnabled",
  },
  {
    name: "Pipette",
    class: "pipette",
    type: "pipette",
    tool: "Pipette",
    icon: "faEyeDropper",
    id: "Pipette",
    layerType: "marker",
    color: "black",
    requiredFeature: "CloneToolEnabled",
  },
];

export default function getAssetStyleInfo(className: string): AssetStyleInfo {
  const style = styles.find((s) => s.class === className);
  if (!style) {
    throw new Error(`Asset style not found for className: ${className}`);
  }
  return { ...style, currentColor: style.currentColor ?? DEFAULT_CURRENT_COLOR };
}
